var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrationsSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49351 14H10.3333C12.3584 14 14 12.3584 14 10.3333V10.3333C14 8.30829 12.3584 6.66667 10.3333 6.66667H5.49351M10.5065 10.3333H5.66666C3.64162 10.3333 2 8.69171 2 6.66667V6.66667C2 4.64162 3.64162 3 5.66667 3H10.5065",
    stroke: "#8927EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsSelected);
export default __webpack_public_path__ + "static/media/integrations-selected.582f00ce4d1523e8a076e98e9ca5ae6f.svg";
export { ForwardRef as ReactComponent };